import { axiosClient } from 'shared/apollo/request';

export interface DonorNameRange {
  start: number;
  end: number;
}

export interface DonorNameCheckResponse {
  detected: boolean;
  matches: DonorNameRange[];
}

const MIN_MEANINGFUL_LENGTH = 4;

export const isMeaningfulProgramName = (name: string | null | undefined) =>
  Boolean(name) && name!.trim().length >= MIN_MEANINGFUL_LENGTH;

export const checkDonorName = async (
  text: string,
  signal?: AbortSignal,
): Promise<DonorNameCheckResponse> => {
  const response = await axiosClient.request<DonorNameCheckResponse>({
    method: 'POST',
    url: '/v4/donor-name/check',
    data: { text },
    signal,
  });
  return response.data;
};
